<template>
  <div class="gap-2 flex items-center justify-around mt-5">
    <div v-for="(friend,index) in friends">
      <a
        :href="index === 12 ? '//9-99ine.com/' : ''"
        target="_blank"
      >
        <img
          :src="friend"
          alt="friend-link"
          class="h-6 min-w-20"
        >
      </a>
    </div>
  </div>
</template>
<script setup>
import Friend1 from '@/assets/layout/friends/friend-1.png'
import Friend2 from '@/assets/layout/friends/friend-2.png'
import Friend3 from '@/assets/layout/friends/friend-3.png'
import Friend4 from '@/assets/layout/friends/friend-4.png'
import Friend5 from '@/assets/layout/friends/friend-5.png'
import Friend6 from '@/assets/layout/friends/friend-6.png'
import Friend7 from '@/assets/layout/friends/friend-7.png'
import Friend8 from '@/assets/layout/friends/friend-8.png'
import Friend9 from '@/assets/layout/friends/friend-9.png'
import Friend10 from '@/assets/layout/friends/friend-10.png'
import Friend11 from '@/assets/layout/friends/friend-11.png'
import Friend12 from '@/assets/layout/friends/friend-12.png'
import Friend13 from '@/assets/layout/friends/friend-13.png'

const friends = [
  Friend1,
  Friend2,
  Friend3,
  Friend4,
  Friend5,
  Friend6,
  Friend7,
  Friend8,
  Friend9,
  Friend10,
  Friend11,
  Friend12,
  Friend13,
]
</script>
